import { render, staticRenderFns } from "./PriceWorkflowPromoType.vue?vue&type=template&id=6033e848&scoped=true&"
import script from "./PriceWorkflowPromoType.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowPromoType.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowPromoType.vue?vue&type=style&index=0&id=6033e848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033e848",
  null
  
)

export default component.exports